import React, { FC } from 'react';
import { Helmet } from 'react-helmet';
import { MetaTagsProps } from './MetaTags.interface';
import { IS_PRODUCTION } from '$shared/constants';

export const MetaTags: FC<MetaTagsProps> = ({
  title,
  description = '',
  image = null,
  faviconIndicator,
  canonical,
  script,
}) => {
  return (
    <Helmet script={script}>
      {title && <title>{title}</title>}
      <meta name="description" content={description} />
      <meta property="og:title" content={title} />
      <meta property="og:description" content={description} />
      <meta property="og:url" content={location.href} />
      <meta name="twitter:title" content={title} />
      <meta property="og:site_name" content="Ton.Place" />
      <meta property="og:type" content="website" />
      {(!IS_PRODUCTION ||
        faviconIndicator !== undefined) && (
          <link
            rel="icon"
            href={
              location.origin +
              (!IS_PRODUCTION
                ? '/favicon_staging.png'
                : faviconIndicator
                ? '/favicon_unread.png'
                : '/favicon.png')
            }
          />
        )}
      {image && [
        <meta key="og" property="og:image" content={image} />,
        <meta key="twitter" name="twitter:image" content={image} />,
      ]}
      {!!canonical && <link rel="canonical" href={canonical} />}
    </Helmet>
  );
};
